import {useCallback, useRef} from 'react';
import {useLayoutEffect} from './useLayoutEffect';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEffectEventPatch<F extends (...args: any[]) => void>(fn: F) {
  const ref = useRef<F | null>(null);
  useLayoutEffect(() => {
    ref.current = fn;
  }, [fn]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useCallback((...args: any) => {
    const f = ref.current;
    return f?.(...args);
  }, []);
}
